import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  logo: {
    fill: theme.palette.type === "light" ? "#000" : "#c2c7cc",
    marginRight: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
  },
}));
